import React, { useEffect, useState } from 'react'
import { LuDot } from 'react-icons/lu'
import TCModal from 'components/organisms/Modal/TCModal'
import LogoFooter from 'assets/icons/LogoFooter'
import { tncCodeList } from 'constant/tncCode'
import useTnC from 'hooks/useTnC'
import { FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from 'react-icons/fa'
import FooterNavList from './FooterNavList'
import NewsletterFooter from './NewsletterFooter'
import { useInView } from 'react-intersection-observer'
import SectionLayout from 'components/templates/SectionLayout'
import {useLocation} from 'react-router-dom'

// Semua tautan nav di footer mengarah ke halaman SSR (isNextUrl={true}).
const exploreOpportunities = [
   {
      id: 'companies-offered',
      path: '/opportunities?tab=buyer',
      name: 'Penawaran Bisnis & Investasi '
   },
   {
      id: 'companies-wanted',
      path: '/opportunities?tab=seller',
      name: 'Cari Bisnis & Investasi'
   },
   { id: 'find-partner', path: '/opportunities?tab=partner', name: 'Cari Partner' }
]

const companyAndSupport = [
   { id: 'about-us', path: '/about-us', name: 'Tentang Tomazz' },
   // { id: 'pricing', path: '/pricing', name: 'Plans & Pricing' },
   { id: 'support', path: '/contact-and-support', name: 'Kontak' },
   { id: 'seller-solution', path: '/seller-landing-page', name: 'Solusi Penjual' },
   { id: 'buyer-solution', path: '/buyer-and-investor-solutions', name: 'Solusi Pembeli' },
   { id: 'partner-solution', path: '/partner-landing-page', name: 'Solusi Partner' }
]

const learnAndGrow = [
   { id: 'connect-days', path: '/connect-days', name: 'Tomazz Connect Days' },
   { id: 'webinar', path: '/webinar', name: 'Webinar' },
   { id: 'blog', path: '/blog', name: 'Blog' }
]

const toolsAndResources = [
   { id: 'knowledge-library', path: '/knowledge-library', name: 'Knowledge Library' },
   { id: 'badges', path: '/badges', name: 'Memahami Lencana' },
   {
      id: 'valuation-tools',
      path: '/services/valuation-tools',
      name: 'Professional Valuation Report'
   }
]

const socialMedia = [
   {
      id: 'instagram',
      Icon: FaInstagram,
      label: 'Instagram',
      href: 'https://www.instagram.com/tomazz.id/'
   },
   {
      id: 'linkedin',
      Icon: FaLinkedin,
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/company/tomazz-indonesia/'
   },
   {
      id: 'tiktok',
      Icon: FaTiktok,
      label: 'TikTok',
      href: 'https://www.tiktok.com/@tomazz.indonesia'
   },
   {
      id: 'youtube',
      Icon: FaYoutube,
      label: 'YouTube',
      href: 'https://www.youtube.com/@TomazzIndonesia'
   }
]
const REFUND_POLICY_HTML = `
<p><strong>KEBIJAKAN PENGEMBALIAN DANA</strong></p>
<br/>
<p><strong>PT Tomazz Bizniz Indonesia</strong><br/><strong>Tanggal Berlaku: 1 Juli 2025</strong></p>
<br/>
<p><strong>1. Ruang Lingkup</strong></p>
<br/>
<p>Kebijakan Pengembalian Dana ini berlaku untuk seluruh pembayaran yang dilakukan kepada PT Tomazz Bizniz Indonesia ("Tomazz") melalui platformnya, termasuk pembayaran Paket Berlangganan, pendaftaran acara, layanan profesional, serta produk atau layanan berbayar lainnya yang ditawarkan oleh Tomazz.</p>
<br/>
<p>Dengan melakukan pembayaran kepada Tomazz, pelanggan dianggap telah memahami dan menyetujui Kebijakan Pengembalian Dana ini.</p>
<br/>
<p><strong>2. Biaya yang Tidak Dapat Dikembalikan</strong></p>
<br/>
<p>Seluruh biaya yang telah dibayarkan kepada Tomazz bersifat final dan tidak dapat dikembalikan, kecuali secara tegas dinyatakan dalam Bagian 3 Kebijakan ini.</p>
<br/>
<p>Biaya tersebut termasuk, tetapi tidak terbatas pada:</p>
<ul style="margin-left:1.25rem">
  <li>Biaya Paket Berlangganan;</li>
  <li>Biaya pendaftaran acara;</li>
  <li>Biaya layanan profesional;</li>
  <li>Biaya konsultasi, kesiapan, penilaian, pelatihan, lokakarya, dan jasa konsultasi lainnya;</li>
  <li>Produk atau layanan berbayar lainnya yang ditawarkan oleh Tomazz.</li>
</ul>
<br/>
<p>Setelah pembayaran berhasil diterima, Tomazz dapat segera memulai proses onboarding, aktivasi akun, verifikasi, peninjauan profil, pemeriksaan kepatuhan, aktivitas dukungan, alokasi sumber daya, atau layanan terkait lainnya. Oleh karena itu, pada umumnya biaya tidak dapat dikembalikan setelah pembayaran diterima.</p>
<br/>
<p>Setiap keterlambatan yang disebabkan oleh informasi yang tidak lengkap, dokumen yang tidak tersedia, penyampaian informasi yang tidak akurat, keterlambatan respons pelanggan, kegagalan memberikan informasi yang diminta, atau kegagalan menyelesaikan tindakan yang diwajibkan tidak memberikan hak kepada pelanggan untuk memperoleh pengembalian dana, kredit, perpanjangan layanan, atau kompensasi.</p>
<br/>
<p>Peninjauan, penolakan, penangguhan, pembatasan, atau penghapusan profil, akun, listing, konten, atau aplikasi oleh Tomazz, termasuk dalam keadaan pelanggan gagal memberikan informasi atau dokumen yang memadai sebagaimana diwajibkan oleh Tomazz, tidak memberikan hak kepada pelanggan untuk memperoleh pengembalian dana, sepanjang tindakan tersebut dilakukan sesuai dengan kebijakan Tomazz, standar verifikasi, persyaratan kualitas, kewajiban hukum, atau kebutuhan bisnis yang wajar.</p>
<br/>
<p><strong>3. Pengecualian</strong></p>
<br/>
<p>Tomazz hanya akan menyetujui pengembalian dana dalam keadaan berikut:</p>
<ul style="margin-left:1.25rem">
  <li>Transaksi tanpa izin atau transaksi penipuan yang dapat dibuktikan;</li>
  <li>Pembayaran ganda yang disebabkan oleh kesalahan teknis atau kesalahan pemrosesan pembayaran;</li>
  <li>Biaya yang secara keliru dibebankan oleh Tomazz;</li>
  <li>Pembatalan acara oleh Tomazz;</li>
  <li>Pembatalan layanan berbayar oleh Tomazz sebelum layanan tersebut dimulai;</li>
  <li>Pengembalian dana yang diwajibkan berdasarkan peraturan perundang-undangan yang berlaku.</li>
</ul>
<br/>
<p>Seluruh permintaan pengembalian dana harus melalui proses verifikasi dan memperoleh persetujuan dari Tomazz.</p>
<br/>
<p><strong>4. Permintaan Pengembalian Dana</strong></p>
<br/>
<p>Permintaan pengembalian dana harus disampaikan melalui:</p>
<ul style="margin-left:1.25rem">
  <li>Email: info@tomazz.co.id</li>
  <li>Telepon/WhatsApp: +62 811-8089-5368</li>
</ul>
<br/>
<p>Permintaan tersebut harus mencantumkan:</p>
<ul style="margin-left:1.25rem">
  <li>Nama lengkap;</li>
  <li>Alamat email yang terdaftar;</li>
  <li>Tanggal transaksi;</li>
  <li>Nomor referensi transaksi atau ID pembayaran;</li>
  <li>Penjelasan mengenai permasalahan yang terjadi;</li>
  <li>Bukti pendukung, apabila diperlukan.</li>
</ul>
<p>Tomazz akan meninjau permintaan tersebut dan memberikan tanggapan dalam waktu lima (5) hari kerja.</p>
<br/>
<p>Pengembalian dana yang telah disetujui akan diproses dalam waktu empat belas (14) hari kerja dan hanya akan dikembalikan melalui metode pembayaran asli yang digunakan dalam transaksi.</p>
<br/>
<p><strong>5. Chargeback atau Sengketa Pembayaran</strong></p>
<br/>
<p>Pelanggan dianjurkan untuk menghubungi Tomazz secara langsung sebelum mengajukan chargeback atau sengketa pembayaran kepada bank, penerbit kartu, atau penyedia layanan pembayaran.</p>
<br/>
<p>Tomazz berhak memberikan catatan transaksi, catatan aktivitas platform, catatan onboarding, aktivitas verifikasi, komunikasi, informasi akun, serta bukti relevan lainnya kepada penyedia layanan pembayaran, penerbit kartu, atau lembaga penyelesaian sengketa sebagai tanggapan atas klaim chargeback.</p>
<br/>
<p><strong>6. Hukum yang Berlaku</strong></p>
<br/>
<p>Kebijakan Pengembalian Dana ini diatur oleh dan ditafsirkan sesuai dengan hukum Republik Indonesia.</p>
<br/>
<p>Setiap perselisihan yang timbul dari atau berkaitan dengan Kebijakan Pengembalian Dana ini akan diselesaikan sesuai dengan Undang-Undang Republik Indonesia Nomor 30 Tahun 1999 tentang Arbitrase dan Alternatif Penyelesaian Sengketa, dengan Jakarta, Indonesia sebagai tempat kedudukan arbitrase.</p>
`

const Footer = () => {
  const { openModal, modal, closeModal, tcContent, isFetchingTnC } = useTnC()
  const [refundPolicyOpen, setRefundPolicyOpen] = useState(false)
  const { ref: footerRef, inView } = useInView({
    threshold: 0.1, // aktif kalau 10% area footer terlihat
    triggerOnce: true
  })
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("/terms-and-conditions")) {
      openModal(tncCodeList.GENERAL);
    }

    if (path.includes("/privacy-policy")) {
      openModal(tncCodeList.PRIVACY_POLICY);
    }
  }, [location.pathname]);

  return (
    <footer
      ref={footerRef}
      className="w-full flex-col flex justify-between items-center bg-brand-default text-white border border-solid border-x-0 border-b-0 border-t-lighter">
      <SectionLayout>
        <NewsletterFooter inView={inView} />
      </SectionLayout>
      {/* NavBottom
          < 640px  : semua grup ditumpuk 1 kolom.
          640-1023 : 2 kolom rapat — kiri (Explore, Company & Support, Tools & Resources) dan
                     kanan (Learn & Grow, Follow us on) masing-masing satu tumpukan flex,
                     jadi tidak ada baris kosong menganga di antara grup.
          >= 1024  : wrapper kolom di-`contents` sehingga tiap grup jadi grid item langsung,
                     lalu ditempatkan sesuai desain 4 kolom via col-start/row-start. */}
      <SectionLayout className="grid w-full grid-cols-1 items-start gap-8 px-4 py-8 sm:grid-cols-2 lg:grid-cols-4">
        {/* TOMAZZ */}
        <div className="w-fit sm:col-span-2 lg:col-span-1 lg:col-start-1 lg:row-start-1">
          <LogoFooter />
        </div>
        <div className="flex flex-col gap-8 lg:contents">
          <div className="flex flex-col gap-4 lg:col-start-2 lg:row-start-1">
            <span className="text-xl font-bold">Jelajahi Peluang</span>
            <FooterNavList navList={exploreOpportunities} isNextUrl={true} />
          </div>
          <div className="flex flex-col gap-4 lg:col-start-2 lg:row-start-2">
            <span className="text-xl font-bold">Perusahaan & Dukungan</span>
            <FooterNavList navList={companyAndSupport} isNextUrl={true} />
          </div>
          <div className="flex flex-col gap-4 lg:col-start-4 lg:row-start-1">
            <span className="text-xl font-bold">Tools &amp; Resources</span>
            <FooterNavList navList={toolsAndResources} isNextUrl={true} />
          </div>
        </div>
        <div className="flex flex-col gap-8 lg:contents">
          <div className="flex flex-col gap-4 lg:col-start-3 lg:row-start-1">
            <span className="text-xl font-bold">Belajar & Berkembang</span>
            <FooterNavList navList={learnAndGrow} isNextUrl={true} />
          </div>
          {/* Social Media */}
          <div className="flex flex-col gap-4 lg:col-start-3 lg:row-start-2">
            <span className="text-xl font-bold">Ikuti Kami</span>
            <SocialMediaList navList={socialMedia} />
          </div>
        </div>
      </SectionLayout>
      {/* Copyright */}
      <div className="bg-surface-brand-1 w-full">
        <div className="mx-auto flex w-full max-w-[1920px] flex-col gap-4 p-4 text-sm lg:flex-row lg:items-center lg:justify-between lg:px-[156px]">
          <span className="text-primary">
            &copy; {new Date().getFullYear()} Tomazz Bizniz International B.V. All rights reserved.
          </span>
          <div className="flex items-center gap-2 flex-nowrap">
            <span
              className="text-primary cursor-pointer hover:text-brand-default"
              onClick={() => openModal(tncCodeList.GENERAL)}>
              Syarat dan Ketentuan
            </span>
            <LuDot className="text-primary" />
            <span
              className="text-primary cursor-pointer hover:text-brand-default"
              onClick={() => openModal(tncCodeList.PRIVACY_POLICY)}>
              Kebijakan Privasi
            </span>
            <LuDot className="text-primary" />
            <span
              className="text-primary cursor-pointer hover:text-brand-default"
              onClick={() => setRefundPolicyOpen(true)}>
              Kebijakan Pengembalian Dana
            </span>
          </div>
        </div>
      </div>
      {modal?.open ? (
        <TCModal
          open={modal?.open}
          onClose={closeModal}
          content={tcContent}
          isLoading={isFetchingTnC}
        />
      ) : null}
      {refundPolicyOpen ? (
        <TCModal
          open={refundPolicyOpen}
          onClose={() => setRefundPolicyOpen(false)}
          content={REFUND_POLICY_HTML}
          isLoading={false}
        />
      ) : null}
    </footer>
  )

  function SocialMediaList({ navList }) {
    return (
      <div className="flex items-center gap-4">
        {navList.map(({ id, Icon, label, href }) => (
          <a
            key={id}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="hover:cursor-pointer">
            <Icon className="h-5 w-5 fill-white hover:fill-lighter" />
          </a>
        ))}
      </div>
    )
  }
}

export default Footer
